//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/VisualReporting.js";
import "../no/NXObject.js";
let d=[[[0,"BitmapName",1,0],[0,"CustomMessage",1,0],[0,"Description",1,0],[0,"DescriptiveCategory",1,0],[0,"DestinationTeamcenterFolder",1,0],[0,"Filename",1,0],[0,"IsUnmatchedGroupEnabled",1,0],[0,"ReportContext",1,0],[0,"ReportingObjectType",1,0],[0,"ReportingStyle",1,0],[0,"SaveDestination",1,0],[0,"ScopeType",0,0],[0,"UnmatchedGroupLabel",0,"VisualReporting.GroupLabel",0],[0,"UnmatchedResultCategory",0,"VisualReporting.UnmatchedResultCategory",0]],[[[],"Save",{},0,0],[["index"],"GetRule",{R_:{rule:"VisualReporting.Rule"}},1,0],[["numRules"],"GetRules",{R_:{rules:"VisualReporting.Rule[]"}},0,0],[["numCategories"],"GetResultCategories",{R_:{categories:"VisualReporting.ResultCategory[]"}},0,0],[["category","numGroupLabels"],"GetGroupLabelsOfResultCategory",{R_:{groupLabels:"VisualReporting.GroupLabel[]"}},1,0],[["numGroupLabels"],"GetGroupLabels",{R_:{groupLabels:"VisualReporting.GroupLabel[]"}},0,0],[["groupLabel","numObjects"],"GetObjectsInGroup",{R_:{nxObjects:"NXObject[]"}},1,0],[[],"GetKeywords",{R_:{keywords:''}},0,0],[["keywords"],"SetKeywords",{},1,0],[["theCategory"],"RemoveResultCategory",{},1,0],[["numProperties"],"GetAllDefinedProperties",{R_:{definedProperties:"VisualReporting.Property[]"}},0,0],[["property","groupLabel","nxObject"],"GetPropertyValueOfObject",{R_:{value:''}},3,0],[["numObjectTypes"],"GetObjectTypes",{R_:{objectTypes:""}},0,0]],[]];
SPLM.VisualReporting.VisualReport = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.VisualReporting.VisualReport";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualReporting.VisualReport.ReportingStyleOption = Object.freeze({
    "ColorObject" : "ColorObject", "TagObject" : "TagObject", "ColorAndTagObject" : "ColorAndTagObject"});

SPLM.VisualReporting.VisualReport.ReportingObjectTypeOption = Object.freeze({
    "Part" : "Part", "Component" : "Component", "Inferred" : "Inferred"});

SPLM.VisualReporting.VisualReport.SaveDestinationOption = Object.freeze({
    "Local" : "Local", "Teamcenter" : "Teamcenter"});

SPLM.VisualReporting.VisualReport.ScopeTypeOption = Object.freeze({
    "Component" : "Component", "SubPart" : "SubPart", "Application" : "Application"});

SPLM.VisualReporting.VisualReport.ObjectTypeOption = Object.freeze({
    "Body" : "Body", "Face" : "Face"});

SPLM.VisualReporting.VisualReport.ReportContextOption = Object.freeze({
    "Assembly" : "Assembly", "WorkPart" : "WorkPart"});

export default SPLM;